import { Controller } from '@hotwired/stimulus';

// Use this controller to scroll an element into view
// Simply add data: {controller: 'common--scroll-to-target'} to the element you want to scroll
// this controller will fire as soon as that element is rendered and the controller connects
export default class extends Controller {
  connect() {
    window.scrollTo({
      top: this.element.getBoundingClientRect().top + window.scrollY,
      behavior: 'smooth',
    });
  }
}
